export default __webpack_public_path__ + "static/media/ic_fare.62c91ca1.svg";